import { Marker, Popup, Tooltip as MapToolTip, useMap } from "react-leaflet";
import { useEffect, useRef } from "react";
import "leaflet-rotatedmarker";
import RotatedMarkerIcon from "./RotatedMarkerIcon";
import CustomMapTooltip from "./CustomMapTooltip";
import _ from "lodash";


function CustomRotatedMarker(props) {
  const { position, selectedAsset, fullscreenmode, item, index, FocusAsset } = props;
  const markerRef = useRef(null);

  const rotationAngle = FocusAsset
    ? _.toNumber(item.angle)
    : item.idleViolationOn === 1
      ? 0
      : item.speedViolationOn === 1
        ? 0
        : _.toNumber(item.angle);

  useEffect(() => {
    const marker = markerRef.current;
    if (marker) {
      marker.setRotationAngle(rotationAngle);
    }
  }, [rotationAngle]);

  return (
    <Marker
      key={index}
      position={position}
      icon={RotatedMarkerIcon(item)}
      rotationAngle={rotationAngle}
      rotationOrigin="center"
      ref={markerRef}
      eventHandlers={{
        click: () => selectedAsset(item),
        mouseover: (e) => e.target.openPopup(),
        mouseout: (e) => e.target.closePopup(),
      }}
    >
      <Popup>
        <CustomMapTooltip
          plateno={item.plateNo}
          issuedby={item.regEmirate}
          make={item.make}
          model={item.modelName}
          driver={item.driverName}
          phone={item.driverPhone}
          speed={item.speed}
          location={item.location}
          time={item.dateTime}
          temp1={item.tSensor1}
          temp2={item.tSensor2}
        />
      </Popup>
      {fullscreenmode === 1 && (
        <MapToolTip
          className="maptooltip"
          direction="bottom"
          offset={[0, 0]}
          opacity={1}
          permanent
        >
          {item.plateNo}
        </MapToolTip>
      )}
    </Marker>
  );
}

export default CustomRotatedMarker;
